import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { CmsBannerComponent, IndexType, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { StartOrderService } from '../../custom-start-order/start-order.service';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { FormBuilder } from '@angular/forms';
import { ContentService } from '../../spartacus/services/content.service';
import { Observable } from 'rxjs';
import { ApiFailureDialogService } from '../../api-failure-dialog/api-failure-dialog.service';
declare const Calendly: any;
@Component({
    selector: 'app-productpage',
    templateUrl: './productpage.component.html',
    styleUrl: './productpage.component.scss',
    standalone: false
})
export class ProductpageComponent {
  showCalendly: boolean=false;
  showClearBtn: boolean = false;
  isAsAgent:boolean=false;
  prodVal: any;
  review:any;
  errorMsg: string = '';
  productData: any;
  seasonValue: string = '';
  deliveryseason:string='';
  totalCost: number = 0.00;
  calendlyData: any;
  disableDeliveryBtn :boolean=true;
  enablePage: any;
  isLoading: boolean = false;
  disabledelivery: boolean = false;
  showDeliveryPage: boolean = false;
  disableRepeatDeliveryBtn: boolean = false;
  isDeliveryBtnClicked: boolean = false;
  showErrorMsg: boolean = false;
  showProductPage: boolean = false;
  deliverydata: any;
  maxdeliveryslot:number=5000;
  mindeliveryslot:number=100;
  minproductdose:number=200;
  maxproductdose:number=10000;
  minproductwithcomma="200";
  maxproductwithcomma="10,000";
  maxdeliveryslotwithcomma="5,000";
  MaxQuantityCheckEnabled:number=0;
 
  emailId: string = 'flu.salesuk@seqirus.com';
  inseason: string = '';
  preseason: string = '';
  prepreseason:string='';
  landingapi: any;
  maxslot:number=4;
  productcontent:any;
  producttext: Observable<any> = this.component.data$;
  productdata:any;
  locationdetails:any=[];
  listarray:string='';
  productimage:any=[];
  productimagedummy:any;
   popupdata: any;
  constructor(private dialogservice:ApiFailureDialogService, protected config: OccConfig,public component: CmsComponentData<CmsBannerComponent>, private cdr: ChangeDetectorRef, private router: Router, private startOrderService: StartOrderService, private userInfoService: UserInfoService, private fb: FormBuilder, private contentservice: ContentService) {

  }
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image?.url;
  }
  ngOnInit() {
   
    this.producttext.subscribe(res => {
      this.productdata=res;
      const list=this.productdata.ProductMedias;
      this.listarray=list.split(" ").join(",");
   
    });
  
     
        this.contentservice.startorder_Landing(this.listarray).subscribe((data:any) => {
          this.productimagedummy=data;
          for(let i=0;i<4;i++){
          this.productimagedummy?.component.forEach((data:any)=>{
            if(data.uid=='ProductImage'+(i+1)){
              this.productimage.push(data);
            }
          });
        }
          this.cdr.detectChanges();
        });
  
    
    this.contentservice.startapi().subscribe(data => {
      
      this.landingapi=data;
      this.inseason=this.landingapi?.currentInSeason;
      this.preseason=this.landingapi?.preSeason;
      this.prepreseason=this.landingapi?.prePreSeason
      this.cdr.detectChanges();
      
    });
    this.producttext.subscribe((res: any) => {
      this.productcontent=res;
      this.cdr.detectChanges();
    });
    
    this.userInfoService.getEnablePage().subscribe(
      (data: any) => {
        this.enablePage = data;
    
        if (this.enablePage.showProductPage || this.showProductPage) {
          this.isLoading = true;
    
          this.userInfoService.getstartorderseason().subscribe(
            (seasonValue: any) => {
              this.seasonValue = seasonValue;
              this.deliveryseason = seasonValue?.split("-")[0];
              this.scrollToTop();
    
              this.startOrderService.getProductData().subscribe(
                (data: any) => {
                  this.cdr.detectChanges();
                  if(data?.errorCode=="500" && localStorage.getItem('FailureDailog') != 'true'){
                    this.dialogservice.openErrorDialog();
                    localStorage.setItem('FailureDailog', 'true');
                    this.isLoading = false;
                    this.cdr.detectChanges();
                          }
    
                  if (data && (this.enablePage.showProductPage || this.showProductPage)) {
                    this.productData = data;
                    this.isLoading = false;

                   this.disableDeliveryBtn=true;
    
                    if (this.productData.constraintList.PrePreBookMaxLocProdQuantityCreateOrder) {
                      this.minproductdose = this.productData.constraintList.PrePreBookMinLocProdQuantityCreateOrder;
                      this.maxproductdose = this.productData.constraintList.PrePreBookMaxLocProdQuantityCreateOrder;
                      this.MaxQuantityCheckEnabled = this.productData?.constraintList?.PrePreBookMaxQuantityCheckEnabledCreateOrder;
                    } else if (this.productData.constraintList.MinLocProdQuantityCreateInSeasonOrder) {
                      this.minproductdose = this.productData.constraintList.MinLocProdQuantityCreateInSeasonOrder;
                      this.maxproductdose = this.productData.constraintList.MaxLocProdQuantityCreateInSeasonOrder;
                      this.MaxQuantityCheckEnabled = this.productData?.constraintList?.MaxQuantityCheckEnabledCreateInSeasonOrder;
                    } else {
                      this.minproductdose = this.productData.constraintList.MinLocProdQuantityCreateOrder;
                      this.maxproductdose = this.productData.constraintList.MaxLocProdQuantityCreateOrder;
                      this.MaxQuantityCheckEnabled = this.productData?.constraintList?.MaxQuantityCheckEnabledCreateOrder;
                    }
    
                    this.minproductwithcomma = this.numberWithCommas(this.minproductdose);
                    this.maxproductwithcomma = this.numberWithCommas(this.maxproductdose);
    
                    this.productData.productList.forEach((el: any) => {
                      el.priceData['errorMsg'] = '';
                      el.priceData['prodValue'] = null;
                    });
    
                    const prodArray = this.productData.productList;
    
                    this.productData.shippingData.forEach((el: any) => {
                      el['productList'] = [];
                      el['productList'] = JSON.parse(JSON.stringify(prodArray));
                      el['disableRemove'] = this.productData.shippingData.length === 1;
                      el['totalcostperlocation'] = "";
                    });

                    this.cdr.detectChanges();
                    this.startOrderService.setProductData(null);
                  }
                },
                (error) => {
                  console.error('Error fetching product data:', error);
                  this.isLoading = false;
                  this.cdr.detectChanges();
                }
              );
              this.startOrderService.geterrorData().subscribe((val:boolean)=>{
                if(val==true){
                  this.isLoading=false;
                  this.cdr.detectChanges();
                }
              });

            },
            (error) => {
              console.error('Error fetching start order season:', error);
              const obj = {
                showLandingPage: false,
                showLocationPage: false,
                showProductPage: false,
                isProductBackBtnClicked: false,
                showReviewPage: false,
                showConfirmThankYouPage: false,
                showSaveThankYouPage: false,
                showSorryPage: true
              };
              this.userInfoService.setInPlaceOrder(false);
              this.userInfoService.setEnablePage(obj);
              this.scrollToTop();
              this.isLoading = false;
              this.cdr.detectChanges();
            }
          );
        }
      
        if (this.enablePage.isDeliveryBackBtnClicked) {
          this.showDeliveryPage = true;
        }
      },
      (error) => {
        console.error('Error fetching enable page:', error);
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
    this.isAsAgent = this.userInfoService.checkAsmUser();
        this.contentservice.getNavigation('calendlyPopUp').subscribe(res => {
          this.popupdata = res;
        });
  }
  handleOnExitClick() {
    this.userInfoService.setPopUpValue(true);
  }
  handleOnPrevValueBtnClick(value: string) {
    this.showClearBtn = value === 'clear';
    this.totalCost = 0.00;
    if (this.showClearBtn) {
      this.productData.shippingData.forEach((el: any) => {
        el.productList.forEach((data: any) => {
           if (data.baseName === 'AQIV') {
            data.priceData.prodValue = !el.previousYearAqivQty ? null : el.previousYearAqivQty.toString();
          } else if (data.baseName === 'QIVC') {
            data.priceData.prodValue = !el.previousYearQivcQty ? null : el.previousYearQivcQty.toString();
          } 
         
          if (data.priceData.prodValue == null) {
            data.priceData.errorMsg = '';
          } else if (data.priceData.prodValue != 0 && (data.priceData.prodValue < this.minproductdose || data.priceData.prodValue > this.maxproductdose)) {
            if(this.MaxQuantityCheckEnabled==0){
              data.priceData.errorMsg = `Please enter at least ${this.minproductwithcomma} doses`;
            }else{
            data.priceData.errorMsg = `Please enter between ${this.minproductwithcomma} & ${this.maxproductwithcomma} doses`;
            }
          } else if (data.priceData.prodValue != 0 && data.priceData.prodValue % 10 != 0) {
            data.priceData.errorMsg = 'Please enter a volume to the nearest unit of 10';
          } else {
            data.priceData.errorMsg = '';
          }
        })
      })
      this.handleOnDisable();
    } else {
      this.isDeliveryBtnClicked = false;
      this.disableDeliveryBtn = true;
      this.cdr.detectChanges();
      this.productData.shippingData.forEach((el: any) => {
        el.productList.forEach((data: any) => {
          data.priceData.prodValue = null;
        })
      })
     
    }
    this.calculateTotalDose();
    this.cdr.detectChanges();
  }
  handleOnProdValueChange(value: string, locIndex: number, prodIndex: number) {
    let productValue :any=value
    if(value){
     productValue = Number(value?.replace(/,/g, ""));
     
    }
    if(isNaN(productValue)){
      productValue=""
    }
      if (productValue == null) {
        this.productData.shippingData[locIndex].productList[prodIndex].priceData.errorMsg = '';
      } else if (productValue != 0 && (productValue < this.minproductdose || productValue > this.maxproductdose)) {
        if(this.MaxQuantityCheckEnabled==0){
          this.productData.shippingData[locIndex].productList[prodIndex].priceData.errorMsg = `Please enter at least ${this.minproductwithcomma} doses`;
        }else{
        this.productData.shippingData[locIndex].productList[prodIndex].priceData.errorMsg = `Please enter between ${this.minproductwithcomma} & ${this.maxproductwithcomma} doses`;
        }
      } else if (productValue != 0 && productValue % 10 != 0) {
        this.productData.shippingData[locIndex].productList[prodIndex].priceData.errorMsg = 'Please enter a volume to the nearest unit of 10';
      } else {
        this.productData.shippingData[locIndex].productList[prodIndex].priceData.errorMsg = '';
      }
     /*  if (this.isDeliveryBtnClicked && this.showClearBtn) {
        this.showErrorMsg = true;
      } */
      if (this.showClearBtn && this.showErrorMsg) {
        let errorMsg = this.productData.shippingData.every((el: any) => {
          let obj;
          const prodValueArray = el.productList.map((data: any) => {  return data.priceData.prodValue });
          const value = prodValueArray.forEach((val: any) => {
            if(val !=null){
              val=val.toString();
               }
            if ((val == null) || (val == '') ) {
              obj = el;
              return obj
            }
          })
          if (obj) {
            return obj;
          }
        })
        if(errorMsg == false || errorMsg==undefined ){
          this.showErrorMsg =false;
        }else{
          this.showErrorMsg =true;
        }
        this.cdr.detectChanges();
      }
    
        this.productData.shippingData[locIndex].productList[prodIndex].priceData.prodValue = this.numberWithCommas(productValue);
       
    this.calculateTotalDose();
    this.handleOnDisable();
    this.cdr.detectChanges();
  }
  calculateTotalDose() {
    this.totalCost = 0.00;
    this.productData.shippingData.forEach((el: any) => {
      let totalperlocation=0;
      el.productList.forEach((el: any) => {
        
        if (el.priceData.prodValue) {
          const material = this.productData.priceResponse.materials.find((data: any) => data.materialID === el.code)
          this.totalCost += (Number(el.priceData.prodValue?.replace(/,/g, "")) * Number(material.salePrice));
          totalperlocation +=(Number(el.priceData.prodValue?.replace(/,/g, "")) * Number(material.salePrice));
        }
      })
      if(totalperlocation!=0){
      el.totalcostperlocation= totalperlocation;
      }else{
        el.totalcostperlocation=""
      }
    })
  }
  onSubmit() {
  }
  handleOnDisable() {
    const eachtotal=0;
    const totalloc=[];
    if (!this.showClearBtn) {
      let disable = true;
      let filteredData = this.productData.shippingData.find((el: any) => {
        return el.productList.find((prod: any) => {
          return (prod.priceData.errorMsg != '')
        })
      })
    /*   this.productData.shippingData.forEach((element: any) => {
        eachtotal=element.productList.
      }) */

      if (!filteredData) {
        disable = this.productData.shippingData.find((el: any) => {

          const prodValueArray = el.productList.map((data: any) => { return Number(data.priceData.prodValue?.replace(/,/g, "")) });
          const value = prodValueArray.every((val: any, index: number) => {
            return ((val == null) || (val == '') || (val == 0) || isNaN(val));
          })
          return value ? el : undefined
        })
      }
      this.disableDeliveryBtn = filteredData == undefined ? disable == undefined ? false : true : true;

   /*    if(this.disableDeliveryBtn =false){
        let sumerror:any=[]
    
      this.productData.shippingData.forEach((location1:any)=>{
        let locationsum=0;
         console.log(location1)
       location1.productList.forEach((prodsum:any)=>{
          locationsum =Number(prodsum?.priceData?.prodValue?.replace(/,/g, "")) + locationsum
        
        })
         if(locationsum<=0){
          sumerror.push(true)
         }else{
          sumerror.push(false)
         }
         
        });
        if(sumerror.find(true)){
          this.disableDeliveryBtn=true;
        }else{
          this.disableDeliveryBtn=false;
        }
      }  */
      this.cdr.detectChanges();
    } else {
      this.disableDeliveryBtn = false;
    }
  }
  handleOnRemoveBtn(index: number) {
    this.productData.shippingData.splice(index, 1);
    if (this.productData.shippingData.length == 1) {
      this.productData.shippingData[0].disableRemove = true;
      this.handleOnDisable();
    }
    this.cdr.detectChanges();
  }
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  handleOnBackbtnClick() {
    
    const obj = {
      showLandingPage: false,
      showLocationPage: true,
      showProductPage: false,
      isProductBackBtnClicked: true,
      showReviewPage: false
    }
    this.scrollToTop();
    this.showProductPage = false;
    this.showClearBtn = false;
    this.showErrorMsg = false;
    
    this.userInfoService.setEnablePage(obj);
    this.cdr.detectChanges();
 
  }
  handleOndeliveryValueChange(deliveryValueString: string, locIndex: number, deliveryIndex: number, materialindex: number) {
    let deliveryValue:any = Number(deliveryValueString.replace(/,/g, ""));
    deliveryValueString=deliveryValueString.trim()
    if(deliveryValueString == ""){
      deliveryValue=null;
    }
   if(!isNaN(deliveryValue)){
    if (deliveryValue != null) {
      if (deliveryValue < this.mindeliveryslot || deliveryValue > this.maxdeliveryslot) {
        this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].deliverySlots[deliveryIndex].producterrorMsg = 'You can enter '+this.mindeliveryslot+ ' - '+this.maxdeliveryslotwithcomma+' doses per selected slot';
      } else if (deliveryValue != 0 && deliveryValue % 10 != 0) {
        this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].deliverySlots[deliveryIndex].producterrorMsg = 'Please enter a volume to the nearest unit of 10';
      } else {

        this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].deliverySlots[deliveryIndex].producterrorMsg = '';
      }
    } else {
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].deliverySlots[deliveryIndex].producterrorMsg = '';

    }
    if(deliveryValue != null){
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].deliverySlots[deliveryIndex].quantity = this.numberWithCommas(deliveryValue);
    }
   
    this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].allocatedvalue = null;
    this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].totalcosteach=null
    this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].deliverySlots.forEach((sum: any) => {
      const numWithoutComma = Number(sum.quantity?.replace(/,/g, ""));
      if(!isNaN(numWithoutComma)){
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].allocatedvalue += numWithoutComma;
      }
      
    });
    
    if (this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].allocatedvalue != this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].qty) {
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].allocatederrorMsg = "sum not match";
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].matchtick = false;
    }
    else {
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].allocatederrorMsg = "";
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].matchtick = true;
    }
    if (this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].allocatedvalue == 0) {
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].allocatedvalue = null;
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].totalcosteach=null


      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].allocatederrorMsg = "";
    }
    if(this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].allocatedvalue != null){
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].totalcosteach= Number(this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].allocatedvalue) * this.deliverydata.productList[materialindex].priceData.value;

      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].allocatedvalue=this.numberWithCommas(this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].allocatedvalue);

      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].totalcosteach="£" + this.numberWithCommas( this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[materialindex].totalcosteach.toFixed(2));
    }
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex]?.materials?.find((loop: any) => {
        if (
          loop.deliverySlots.find((check: any) => {

            return check.producterrorMsg == "You can enter "+this.mindeliveryslot+" - "+this.maxdeliveryslotwithcomma+" doses per selected slot";
          })) {
            if(this.MaxQuantityCheckEnabled==1){
              this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].locationmsg = "You can enter "+this.mindeliveryslot+" - "+this.maxdeliveryslotwithcomma+" doses per selected slot"
            }else{
              this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].locationmsg = "You can enter at least "+this.mindeliveryslot+" doses per selected slot"

            }
          return this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].locationlevelerror=true;
        }
       
         else if (
          loop.deliverySlots.find((check: any) => {
            return check.producterrorMsg == "Please enter a volume to the nearest unit of 10";
          })) {
          this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].locationmsg = 'Please enter a volume to the nearest unit of 10'
          return this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].locationlevelerror=true;
        } else {
          this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].locationmsg = ''
          return this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].locationlevelerror=false;
        }
      });

    this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].locationsumerror =

      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials.some((sum: any) => {
        return (sum.allocatederrorMsg != '')

      });
   
    this.handledeliverybtn();
    this.totalcost(locIndex);
    this.cdr.detectChanges();
   }
  }
  totalcost(locIndex:number){
    this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].totalcost=null;
    if(this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[0]?.totalcosteach &&  this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[1]?.totalcosteach){
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].totalcost=Number(this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex]?.materials[0].totalcosteach.replace(/[£,]/g, ""))+ Number(this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex]?.materials[1].totalcosteach.replace(/[£,]/g, ""));
    }else if(this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[0]?.totalcosteach){
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].totalcost=Number(this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex]?.materials[0].totalcosteach.replace(/[£,]/g, ""));

    }else if(this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].materials[1]?.totalcosteach){
      this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex].totalcost=Number(this.deliverydata.deliverySlotResponseData.shippingLocations[locIndex]?.materials[1].totalcosteach.replace(/[£,]/g, ""));

    }
    this.cdr.detectChanges();
  }

  handledelvierynanbuusiiness(event:Event,locIndex: number, deliveryIndex: number, materialindex: number,materiallength:number){
    let value1:any =  (event.target as HTMLInputElement).value;
    value1= Number(value1?.replace(/,/g, ""));
    if(isNaN(value1)){
      (event.target as HTMLInputElement).value=''
     this.handleOndeliveryValueChange('', locIndex, deliveryIndex, materialindex);
     this.businessrule(locIndex,deliveryIndex,event,materiallength);

      this.cdr.detectChanges();
    }else{
      this.businessrule(locIndex,deliveryIndex,event,materiallength);
    }
  }
  handledelvierynan(event:Event,locIndex: number, deliveryIndex: number, materialindex: number){
    let value1:any =  (event.target as HTMLInputElement).value;
    value1= Number(value1?.replace(/,/g, ""));
    if(isNaN(value1)){
      (event.target as HTMLInputElement).value=''
     this.handleOndeliveryValueChange('', locIndex, deliveryIndex, materialindex);

      this.cdr.detectChanges();
    }
  }
  handlenan(event:Event){
    let value1:any =  (event.target as HTMLInputElement).value;
    value1= Number(value1?.replace(/,/g, ""));
    if(isNaN(value1)){
      (event.target as HTMLInputElement).value=''
      this.cdr.detectChanges();
    }
  }
 
  handledeliverybtn() {
    this.disabledelivery =
      this.deliverydata?.deliverySlotResponseData?.shippingLocations.every((ell: any) => {
        if (
          ell.materials.find((check: any) => {
            return (check.matchtick != true);
          })) {
          return false;
        }
        else { 
        
          return (ell.locationsumerror != true && ell.locationlevelerror != true)
        }
        
      });
  }
  businessrule(locationnumber: number, inputnumber: number, event: Event, product: number) {
    const element = (event.target as HTMLInputElement);
    if (product==2) {
      if (element.value.length > 0) {
        for (let i = 0; i < this.deliverydata.deliverySlotConstraintList.maxDeliverySlots; i++) {
         /*  const aqiv = <HTMLElement>document.getElementById("aqivfirst[" + locationnumber + "][" + i + "]");
          const qivc = <HTMLElement>document.getElementById("qivcfirst[" + locationnumber + "][" + i + "]");
          if (i != inputnumber) {
            aqiv?.classList.add("ruleapplied");
            qivc?.classList.add("ruleapplied");
            aqiv?.setAttribute("disabled", "disabled");
            qivc?.setAttribute("disabled", "disabled");
          } */
            if (i != inputnumber) {
         this.deliverydata.deliverySlotResponseData.shippingLocations[locationnumber].materials[0].deliverySlots[i].disablerule=true;
         this.deliverydata.deliverySlotResponseData.shippingLocations[locationnumber].materials[1].deliverySlots[i].disablerule=true;
            }
        }

      } else {
        const currentaqiv = <HTMLInputElement>document.getElementById("aqivfirst[" + locationnumber + "][" + inputnumber + "]");
        const currentqivc = <HTMLInputElement>document.getElementById("qivcfirst[" + locationnumber + "][" + inputnumber + "]");

        if (currentqivc.value.length <= 0 && currentaqiv.value.length <= 0) {
          for (let i = 0; i < this.deliverydata.deliverySlotConstraintList.maxDeliverySlots; i++) {
           /*  const aqiv = <HTMLElement>document.getElementById("aqivfirst[" + locationnumber + "][" + i + "]");
            const qivc = <HTMLElement>document.getElementById("qivcfirst[" + locationnumber + "][" + i + "]");

            aqiv?.classList.remove("ruleapplied");
            qivc?.classList.remove("ruleapplied");
            aqiv?.removeAttribute("disabled");
            qivc?.removeAttribute("disabled"); */
            this.deliverydata.deliverySlotResponseData.shippingLocations[locationnumber].materials[0].deliverySlots[i].disablerule=false;
            this.deliverydata.deliverySlotResponseData.shippingLocations[locationnumber].materials[1].deliverySlots[i].disablerule=false;
          }
        }
      }
    }
    else {
      let inputelement = element.id;
      inputelement = inputelement.split("[")[0];
      if (element.value.length > 0) {
        for (let i = 0; i < this.deliverydata.deliverySlotConstraintList.maxDeliverySlots; i++) {
/*           const product = <HTMLElement>document.getElementById(inputelement + "[" + locationnumber + "][" + i + "]");
 */          if (i != inputnumber) {
  this.deliverydata.deliverySlotResponseData.shippingLocations[locationnumber].materials[0].deliverySlots[i].disablerule=true;

          /*   product?.classList.add("ruleapplied");
            product?.setAttribute("disabled", "disabled"); */

          }
        }
      } else {
        for (let i = 0; i < this.deliverydata.deliverySlotConstraintList.maxDeliverySlots; i++) {
      /*     const product = <HTMLElement>document.getElementById(inputelement + "[" + locationnumber + "][" + i + "]");
          product?.classList.remove("ruleapplied");
          product?.removeAttribute("disabled"); */
          this.deliverydata.deliverySlotResponseData.shippingLocations[locationnumber].materials[0].deliverySlots[i].disablerule=false;

        }
      }
    }
   
  
   

  
  }
  handleOnDeliveryBtnClick() {
   this.disabledelivery=false;
    let errorMsg;
    if (!this.showClearBtn) {
      this.isDeliveryBtnClicked = false;
      this.showErrorMsg = false;
      this.constructProductPayload();
    } else {
      this.isDeliveryBtnClicked = true;
      let errorData = this.productData.shippingData.find((el: any) => {
        return el.productList.find((prod: any) => {
          return (prod.priceData.errorMsg != '')
        })
      })
  if(!errorData){
       errorMsg = this.productData.shippingData.find((el: any) => {
        let obj;
        const prodValueArray = el.productList.map((data: any,index:number) => { 
          if(data.priceData.prodValue){
          return Number(data.priceData.prodValue?.replace(/,/g, ""));
          }else{
           return data.priceData.prodValue
       }
       });
        
        const value = prodValueArray.find((val: any) => {
          if(val !=null){
         val=val.toString();
          }
          if (((val == null) || (val ==''))) {
 

            obj ="error";
            return obj
          }
          else{
            return 
          }
        })
        if (obj) {
          return obj;
        }
        else{
          if(Number(el.productList[0].priceData.prodValue?.replace(/,/g, ""))    + Number(el.productList[1].priceData.prodValue?.replace(/,/g, "")) <=0){
            return "sumnot match"
          }else{
            return obj
          }
        }
      })
    }

   

      this.showErrorMsg =errorData==undefined? errorMsg == undefined ? false : true:true;
     
      !this.showErrorMsg && this.constructProductPayload();
    }
    this.cdr.detectChanges();
  }
  handleOnBackToProductBtnClick() {
    this.showDeliveryPage = false;
    this.showProductPage = true;
    this.scrollToTop();
  }

  handleOnReviewOrderBtnClick() {
    
    this.showDeliveryPage = false;
    this.showProductPage = false;
    const obj = {
      showLandingPage: false,
      showLocationPage: false,
      showProductPage: false,
      isProductBackBtnClicked: false,
      showReviewPage: true,
    }
    this.userInfoService.setEnablePage(obj);
    let createOrderData = this.deliverydata.deliverySlotResponseData.shippingLocations.map((el: any) => {
      const createOrderProductData = el.materials.map((data: any) => {
        const createOrderDeliverySlotData = data.deliverySlots.map((del: any) => {
          return{
            month: del.month,
            date: del.date,
            deliverySlotWeek: del.week,
            available:del.available,
            disablerule:del.disablerule,
            quantity: Number(del.quantity?.replace(/,/g, ""))
          }
        })

        return {
          productCode:data.materialID,
          productQuantity: data.qty,
          createOrderDeliverySlotData:createOrderDeliverySlotData
        }
      })
      return {
       locID: el.shippingLocID,
       qty50to64y: el.qty50to64y,
       createOrderProductData:createOrderProductData
      }
    })

    const delpayload = {
      totalCost: this.totalCost.toString(),
      requestType: this.productData.priceResponse.requestType.includes('CR') ? "CR" : "AM",
      orderType: this.productData.priceResponse.requestType.includes('CR') ? "CREATE" : "AMEND",
      season: this.seasonValue,
      priceResponse: this.productData.priceResponse,
      constraintList:JSON.stringify(this.deliverydata.deliverySlotConstraintList),
      createOrderData: createOrderData
    }
    this.startOrderService.getreviewpage(delpayload);
    this.cdr.detectChanges();
    
    this.scrollToTop();
  }
  constructProductPayload(){
    let createOrderData = this.productData.shippingData.map((el: any) => {
      const createOrderProductData = el.productList.map((data: any) => {
        return {
          productCode: Number(data.code),
          productQuantity: Number(data.priceData.prodValue?.replace(/,/g, ""))
        }
      })
      return {
        creditDays: this.productData.priceResponse.creditDays,
        sorNumber: this.productData.priceResponse.SOR,
        locID: el.locID,
        createOrderProductData: createOrderProductData
      }
    })
    const payload = {
      totalCost: this.totalCost.toString(),
      requestType: this.productData.priceResponse.requestType.includes('CR') ? "CR" : "AM",
      orderType: this.productData.priceResponse.requestType.includes('CR') ? "CREATE" : "AMEND",
      season: this.seasonValue,
      priceResponse: this.productData.priceResponse,
      createOrderData: createOrderData
    }
    this.isLoading = true;
    this.startOrderService.getUkDeliverySlots(payload).subscribe((data: any) => {
      if(data?.errorCode=="500" && localStorage.getItem('FailureDailog') != 'true'){
        this.isLoading=false;
        this.dialogservice.openErrorDialog();
        localStorage.setItem('FailureDailog', 'true');
        this.cdr.detectChanges();
      }

      this.deliverydata = data;
      this.scrollToTop();
     
      this.deliverydata.deliverySlotConstraintList=JSON.parse(this.deliverydata?.deliverySlotConstraintList)
      if(this.seasonValue==this.deliverydata.createOrderSeasonData.prePreSeason){
        this.maxdeliveryslot=this.deliverydata.deliverySlotConstraintList.PrePreBookMaxDelSlotQtyforProdCreateOrder;
        this.mindeliveryslot=this.deliverydata.deliverySlotConstraintList.PrePreBookMinDelSlotQtyforProdCreateOrder;
        this.maxslot=this.deliverydata.deliverySlotConstraintList.maxDeliverySlots;
      }else if(this.deliverydata.deliverySlotConstraintList.InSeasonMaxDelSlotQtyforProdCreateOrder){
        this.maxdeliveryslot=this.deliverydata.deliverySlotConstraintList.InSeasonMaxDelSlotQtyforProdCreateOrder;
        this.mindeliveryslot=this.deliverydata.deliverySlotConstraintList.InSeasonMinDelSlotQtyforProdCreateOrder;
        if(this.deliverydata.deliverySlotConstraintList.maxDeliverySlots==0){
          this.maxslot=4;
         }
         else{
          this.maxslot=this.deliverydata.deliverySlotConstraintList.maxDeliverySlots;
         }
      }else{
        this.maxdeliveryslot=this.deliverydata.deliverySlotConstraintList.MaxDelSlotQtyforProdCreateOrder;
        this.mindeliveryslot=this.deliverydata.deliverySlotConstraintList.MinDelSlotQtyforProdCreateOrder;
        this.maxslot=this.deliverydata.deliverySlotConstraintList.maxDeliverySlots;
      }
        
       
      
      this.maxdeliveryslotwithcomma=this.numberWithCommas(this.maxdeliveryslot)
    
      this.deliverydata?.deliverySlotResponseData?.shippingLocations.forEach((el: any) => {
        el['locationlevelerror'] = false;
        el['locationmsg'] = '';
        el['locationsumerror'] = false;
        el['totalcost']=null;
  
        el.materials.forEach((sel: any) => {
          sel['allocatederrorMsg'] = '';
          sel['allocatedvalue'] = null;
          sel['totalcosteach']=null;
          sel['matchtick'] = false;
  
          /* if(sel.materialID==this.deliverydata?.productList[0]?.code){ */
          sel.deliverySlots.forEach((del: any) => {
            del['producterrorMsg'] = '';
            del['quantity'] = null
            del['disablerule']=false
          });
          /*} else if(sel.materialID==this.deliverydata?.productList[1]?.code){
            sel.deliverySlots.forEach((del:any)=>{
              del['product2errorMsg']='';
              del['product2value']=0
             });
            } */
        });
  
      });
      for(let i=0;i<this.deliverydata?.deliverySlotResponseData.shippingLocations?.length;i++){
        this.deliverydata?.shippingData.forEach((el:any)=>{
          if(el.locID==this.deliverydata.deliverySlotResponseData.shippingLocations[i].shippingLocID){
             if(el.state){
              this.locationdetails.push(''+el.locname + el.address + el.state+'');
             }
             else{
              this.locationdetails.push(''+el.locname + el.address+'');
             }
            //spacing as per the request
          }
        })
      }
      this.showDeliveryPage = true;
      this.isLoading = false;
      this.cdr.detectChanges();
    }, (error) => {
      console.log('error: ', error);
      this.isLoading = false;
      this.userInfoService.setInPlaceOrder(false);
      this.startOrderService.setApiFailurePopup(true);
      this.isLoading = false;
      this.cdr.detectChanges();
    })
  }
  numberWithCommas(number: number) {
    var parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
 
  ngAfterViewInit(){
    this.contentservice.vsscontent().subscribe(value => { 
      this.calendlyData = value;
     this.cdr.detectChanges();
    })
  }
 
   openCalendly() {
    if (this.calendlyData) {
       window.open(this.calendlyData.calendlyId, '_blank');
     }
   }
 openModal() {
    document.body.style.overflowY = 'auto';
    document.getElementById('orders_commonleaving_abandonedPop')!.style.display = 'block';
    this.cdr.detectChanges();
  }
  closeModal() {
    document.body.style.overflowY = 'auto';
    document.getElementById('orders_commonleaving_abandonedPop')!.style.display = 'none';
  }

}
